function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { PureComponent, createRef } from 'react';
import isEqual from 'react-fast-compare';
import { debounce } from '../../utilities/debounce.js';
import { classNames } from '../../utilities/css.js';
import { headerCell } from '../shared.js';
import { measureColumn, getPrevAndCurrentColumns } from './utilities.js';
import styles from './DataTable.scss.js';
import { Cell } from './components/Cell/Cell.js';
import { Pagination } from '../Pagination/Pagination.js';
import { AfterInitialMount } from '../AfterInitialMount/AfterInitialMount.js';
import { Sticky } from '../Sticky/Sticky.js';
import { Navigation } from './components/Navigation/Navigation.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { EventListener } from '../EventListener/EventListener.js';
var getRowClientHeights = function getRowClientHeights(rows) {
  var heights = [];
  if (!rows) {
    return heights;
  }
  rows.forEach(function (row) {
    heights.push(row.clientHeight);
  });
  return heights;
};
var DataTableInner = /*#__PURE__*/function (_PureComponent) {
  function DataTableInner() {
    var _this;
    _classCallCheck(this, DataTableInner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DataTableInner, [].concat(args));
    _this.state = {
      condensed: false,
      columnVisibilityData: [],
      isScrolledFarthestLeft: true,
      isScrolledFarthestRight: false,
      rowHovered: undefined
    };
    _this.dataTable = /*#__PURE__*/createRef();
    _this.scrollContainer = /*#__PURE__*/createRef();
    _this.table = /*#__PURE__*/createRef();
    _this.stickyTable = /*#__PURE__*/createRef();
    _this.stickyNav = null;
    _this.headerNav = null;
    _this.tableHeadings = [];
    _this.stickyHeadings = [];
    _this.tableHeadingWidths = [];
    _this.stickyHeaderActive = false;
    _this.scrollStopTimer = null;
    _this.handleResize = debounce(function () {
      var _this2 = _this,
        table = _this2.table.current,
        scrollContainer = _this2.scrollContainer.current;
      var condensed = false;
      if (table && scrollContainer) {
        // safari sometimes incorrectly sets the scrollwidth too large by 1px
        condensed = table.scrollWidth > scrollContainer.clientWidth + 1;
      }
      _this.setState(_objectSpread({
        condensed: condensed
      }, _this.calculateColumnVisibilityData(condensed)));
    });
    _this.setCellRef = function (_ref) {
      var ref = _ref.ref,
        index = _ref.index,
        inStickyHeader = _ref.inStickyHeader;
      if (ref == null) {
        return;
      }
      if (inStickyHeader) {
        _this.stickyHeadings[index] = ref;
        var button = ref.querySelector('button');
        if (button == null) {
          return;
        }
        button.addEventListener('focus', _this.handleHeaderButtonFocus);
      } else {
        _this.tableHeadings[index] = ref;
        _this.tableHeadingWidths[index] = ref.clientWidth;
      }
    };
    _this.changeHeadingFocus = function () {
      var _this3 = _this,
        tableHeadings = _this3.tableHeadings,
        stickyHeadings = _this3.stickyHeadings,
        stickyNav = _this3.stickyNav,
        headerNav = _this3.headerNav;
      var stickyFocusedItemIndex = stickyHeadings.findIndex(function (item) {
        var _document$activeEleme;
        return item === ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.parentElement);
      });
      var tableFocusedItemIndex = tableHeadings.findIndex(function (item) {
        var _document$activeEleme2;
        return item === ((_document$activeEleme2 = document.activeElement) === null || _document$activeEleme2 === void 0 ? void 0 : _document$activeEleme2.parentElement);
      });
      var arrowsInStickyNav = stickyNav === null || stickyNav === void 0 ? void 0 : stickyNav.querySelectorAll('button');
      var arrowsInHeaderNav = headerNav === null || headerNav === void 0 ? void 0 : headerNav.querySelectorAll('button');
      var stickyFocusedNavIndex = -1;
      arrowsInStickyNav === null || arrowsInStickyNav === void 0 || arrowsInStickyNav.forEach(function (item, index) {
        if (item === document.activeElement) {
          stickyFocusedNavIndex = index;
        }
      });
      var headerFocusedNavIndex = -1;
      arrowsInHeaderNav === null || arrowsInHeaderNav === void 0 || arrowsInHeaderNav.forEach(function (item, index) {
        if (item === document.activeElement) {
          headerFocusedNavIndex = index;
        }
      });
      if (stickyFocusedItemIndex < 0 && tableFocusedItemIndex < 0 && stickyFocusedNavIndex < 0 && headerFocusedNavIndex < 0) {
        return null;
      }
      var button;
      if (stickyFocusedItemIndex >= 0) {
        button = tableHeadings[stickyFocusedItemIndex].querySelector('button');
      } else if (tableFocusedItemIndex >= 0) {
        button = stickyHeadings[tableFocusedItemIndex].querySelector('button');
      }
      if (stickyFocusedNavIndex >= 0) {
        button = arrowsInHeaderNav === null || arrowsInHeaderNav === void 0 ? void 0 : arrowsInHeaderNav[stickyFocusedNavIndex];
      } else if (headerFocusedNavIndex >= 0) {
        button = arrowsInStickyNav === null || arrowsInStickyNav === void 0 ? void 0 : arrowsInStickyNav[headerFocusedNavIndex];
      }
      if (button == null) {
        return null;
      }
      button.style.visibility = 'visible';
      button.focus();
      button.style.removeProperty('visibility');
    };
    _this.calculateColumnVisibilityData = function (condensed) {
      var fixedFirstColumns = _this.fixedFirstColumns();
      var _this4 = _this,
        table = _this4.table.current,
        scrollContainer = _this4.scrollContainer.current,
        dataTable = _this4.dataTable.current;
      var stickyHeader = _this.props.stickyHeader;
      if ((stickyHeader || condensed) && table && scrollContainer && dataTable) {
        var headerCells = table.querySelectorAll(headerCell.selector);
        var rightMostHeader = headerCells[fixedFirstColumns - 1];
        var nthColumnWidth = fixedFirstColumns ? rightMostHeader.offsetLeft + rightMostHeader.offsetWidth : 0;
        if (headerCells.length > 0) {
          var firstVisibleColumnIndex = headerCells.length - 1;
          var tableLeftVisibleEdge = scrollContainer.scrollLeft + nthColumnWidth;
          var tableRightVisibleEdge = scrollContainer.scrollLeft + dataTable.offsetWidth;
          var tableData = {
            firstVisibleColumnIndex: firstVisibleColumnIndex,
            tableLeftVisibleEdge: tableLeftVisibleEdge,
            tableRightVisibleEdge: tableRightVisibleEdge
          };
          var columnVisibilityData = _toConsumableArray(headerCells).map(measureColumn(tableData));
          var lastColumn = columnVisibilityData[columnVisibilityData.length - 1];
          var isScrolledFarthestLeft = fixedFirstColumns ? tableLeftVisibleEdge === nthColumnWidth : tableLeftVisibleEdge === 0;
          return _objectSpread(_objectSpread({
            columnVisibilityData: columnVisibilityData
          }, getPrevAndCurrentColumns(tableData, columnVisibilityData)), {}, {
            isScrolledFarthestLeft: isScrolledFarthestLeft,
            isScrolledFarthestRight: lastColumn.rightEdge <= tableRightVisibleEdge
          });
        }
      }
      return {
        columnVisibilityData: [],
        previousColumn: undefined,
        currentColumn: undefined
      };
    };
    _this.handleHeaderButtonFocus = function (event) {
      var _this$state$columnVis;
      var fixedFirstColumns = _this.fixedFirstColumns();
      if (_this.scrollContainer.current == null || event.target == null || _this.state.columnVisibilityData.length === 0) {
        return;
      }
      var target = event.target;
      var currentCell = target.parentNode;
      var tableScrollLeft = _this.scrollContainer.current.scrollLeft;
      var tableViewableWidth = _this.scrollContainer.current.offsetWidth;
      var tableRightEdge = tableScrollLeft + tableViewableWidth;
      var nthColumnWidth = _this.state.columnVisibilityData.length > 0 ? (_this$state$columnVis = _this.state.columnVisibilityData[fixedFirstColumns]) === null || _this$state$columnVis === void 0 ? void 0 : _this$state$columnVis.rightEdge : 0;
      var currentColumnLeftEdge = currentCell.offsetLeft;
      var currentColumnRightEdge = currentCell.offsetLeft + currentCell.offsetWidth;
      if (tableScrollLeft > currentColumnLeftEdge - nthColumnWidth) {
        _this.scrollContainer.current.scrollLeft = currentColumnLeftEdge - nthColumnWidth;
      }
      if (currentColumnRightEdge > tableRightEdge) {
        _this.scrollContainer.current.scrollLeft = currentColumnRightEdge - tableViewableWidth;
      }
    };
    _this.stickyHeaderScrolling = function () {
      var stickyTable = _this.stickyTable.current;
      var scrollContainer = _this.scrollContainer.current;
      if (stickyTable == null || scrollContainer == null) {
        return;
      }
      stickyTable.scrollLeft = scrollContainer.scrollLeft;
    };
    _this.scrollListener = function () {
      var _this$scrollContainer;
      if (_this.scrollStopTimer) {
        clearTimeout(_this.scrollStopTimer);
      }
      _this.scrollStopTimer = setTimeout(function () {
        _this.setState(function (prevState) {
          return _objectSpread({}, _this.calculateColumnVisibilityData(prevState.condensed));
        });
      }, 100);
      _this.setState({
        isScrolledFarthestLeft: ((_this$scrollContainer = _this.scrollContainer.current) === null || _this$scrollContainer === void 0 ? void 0 : _this$scrollContainer.scrollLeft) === 0
      });
      if (_this.props.stickyHeader && _this.stickyHeaderActive) {
        _this.stickyHeaderScrolling();
      }
    };
    _this.handleHover = function (row) {
      return function () {
        _this.setState({
          rowHovered: row
        });
      };
    };
    _this.handleFocus = function (event) {
      var _this$state$columnVis2;
      var fixedFirstColumns = _this.fixedFirstColumns();
      if (_this.scrollContainer.current == null || event.target == null) {
        return;
      }
      var currentCell = event.target.parentNode;
      var fixedNthColumn = _this.props;
      var nthColumnWidth = fixedNthColumn ? (_this$state$columnVis2 = _this.state.columnVisibilityData[fixedFirstColumns]) === null || _this$state$columnVis2 === void 0 ? void 0 : _this$state$columnVis2.rightEdge : 0;
      var currentColumnLeftEdge = currentCell.offsetLeft;
      var desiredScrollLeft = currentColumnLeftEdge - nthColumnWidth;
      if (_this.scrollContainer.current.scrollLeft > desiredScrollLeft) {
        _this.scrollContainer.current.scrollLeft = desiredScrollLeft;
      }

      // focus fixed first column if present
    };
    _this.navigateTable = function (direction) {
      var _this$state$columnVis3;
      var fixedFirstColumns = _this.fixedFirstColumns();
      var _this$state = _this.state,
        currentColumn = _this$state.currentColumn,
        previousColumn = _this$state.previousColumn;
      var nthColumnWidth = (_this$state$columnVis3 = _this.state.columnVisibilityData[fixedFirstColumns - 1]) === null || _this$state$columnVis3 === void 0 ? void 0 : _this$state$columnVis3.rightEdge;
      if (!currentColumn || !previousColumn) {
        return;
      }
      var prevWidths = 0;
      for (var index = 0; index < currentColumn.index; index++) {
        prevWidths += _this.state.columnVisibilityData[index].width;
      }
      var scrollContainer = _this.scrollContainer.current;
      var handleScroll = function handleScroll() {
        var newScrollLeft = 0;
        if (fixedFirstColumns) {
          newScrollLeft = direction === 'right' ? prevWidths - nthColumnWidth + currentColumn.width : prevWidths - previousColumn.width - nthColumnWidth;
        } else {
          newScrollLeft = direction === 'right' ? currentColumn.rightEdge : previousColumn.leftEdge;
        }
        if (scrollContainer) {
          scrollContainer.scrollLeft = newScrollLeft;
          requestAnimationFrame(function () {
            _this.setState(function (prevState) {
              return _objectSpread({}, _this.calculateColumnVisibilityData(prevState.condensed));
            });
          });
        }
      };
      return handleScroll;
    };
    _this.renderHeading = function (_ref2) {
      var heading = _ref2.heading,
        headingIndex = _ref2.headingIndex,
        inFixedNthColumn = _ref2.inFixedNthColumn,
        inStickyHeader = _ref2.inStickyHeader;
      var _this$props = _this.props,
        sortable = _this$props.sortable,
        _this$props$truncate = _this$props.truncate,
        truncate = _this$props$truncate === void 0 ? false : _this$props$truncate,
        columnContentTypes = _this$props.columnContentTypes,
        defaultSortDirection = _this$props.defaultSortDirection,
        _this$props$initialSo = _this$props.initialSortColumnIndex,
        initialSortColumnIndex = _this$props$initialSo === void 0 ? 0 : _this$props$initialSo,
        verticalAlign = _this$props.verticalAlign,
        firstColumnMinWidth = _this$props.firstColumnMinWidth;
      var fixedFirstColumns = _this.fixedFirstColumns();
      var _this$state2 = _this.state,
        _this$state2$sortDire = _this$state2.sortDirection,
        sortDirection = _this$state2$sortDire === void 0 ? defaultSortDirection : _this$state2$sortDire,
        _this$state2$sortedCo = _this$state2.sortedColumnIndex,
        sortedColumnIndex = _this$state2$sortedCo === void 0 ? initialSortColumnIndex : _this$state2$sortedCo,
        isScrolledFarthestLeft = _this$state2.isScrolledFarthestLeft;
      var sortableHeadingProps;
      var headingCellId = "heading-cell-".concat(headingIndex);
      var stickyHeaderId = "stickyheader-".concat(headingIndex);
      var id = inStickyHeader ? stickyHeaderId : headingCellId;
      if (sortable) {
        var isSortable = sortable[headingIndex];
        var isSorted = isSortable && sortedColumnIndex === headingIndex;
        var direction = isSorted ? sortDirection : 'none';
        sortableHeadingProps = {
          defaultSortDirection: defaultSortDirection,
          sorted: isSorted,
          sortable: isSortable,
          sortDirection: direction,
          onSort: _this.defaultOnSort(headingIndex),
          fixedNthColumn: fixedFirstColumns,
          inFixedNthColumn: fixedFirstColumns
        };
      }
      var stickyCellWidth = inStickyHeader ? _this.tableHeadingWidths[headingIndex] : undefined;
      var fixedCellVisible = !isScrolledFarthestLeft;
      var cellProps = _objectSpread(_objectSpread({
        header: true,
        stickyHeadingCell: inStickyHeader,
        content: heading,
        contentType: columnContentTypes[headingIndex],
        nthColumn: headingIndex < fixedFirstColumns,
        fixedFirstColumns: fixedFirstColumns,
        truncate: truncate,
        headingIndex: headingIndex
      }, sortableHeadingProps), {}, {
        verticalAlign: verticalAlign,
        handleFocus: _this.handleFocus,
        stickyCellWidth: stickyCellWidth,
        fixedCellVisible: fixedCellVisible,
        firstColumnMinWidth: firstColumnMinWidth
      });
      if (inFixedNthColumn && inStickyHeader) {
        var _this$state$columnVis4;
        // need two cells for fixed first column (actual cell and the overlapping one)
        // the sticky cell is second so that the index is associated with the sticky
        // cell and not the underlying one. This helps `changeHeadingFocus` to put
        // focus on the right cell when switching from sticky to non-sticky headers
        return [/*#__PURE__*/React.createElement(Cell, Object.assign({
          key: id
        }, cellProps, {
          setRef: function setRef(ref) {
            _this.setCellRef({
              ref: ref,
              index: headingIndex,
              inStickyHeader: inStickyHeader
            });
          },
          inFixedNthColumn: false
        })), /*#__PURE__*/React.createElement(Cell, Object.assign({
          key: "".concat(id, "-sticky")
        }, cellProps, {
          setRef: function setRef(ref) {
            _this.setCellRef({
              ref: ref,
              index: headingIndex,
              inStickyHeader: inStickyHeader
            });
          },
          inFixedNthColumn: Boolean(fixedFirstColumns),
          lastFixedFirstColumn: headingIndex === fixedFirstColumns - 1,
          style: {
            left: (_this$state$columnVis4 = _this.state.columnVisibilityData[headingIndex]) === null || _this$state$columnVis4 === void 0 ? void 0 : _this$state$columnVis4.leftEdge
          }
        }))];
      }
      return /*#__PURE__*/React.createElement(Cell, Object.assign({
        key: id
      }, cellProps, {
        setRef: function setRef(ref) {
          _this.setCellRef({
            ref: ref,
            index: headingIndex,
            inStickyHeader: inStickyHeader
          });
        },
        lastFixedFirstColumn: headingIndex === fixedFirstColumns - 1,
        inFixedNthColumn: inFixedNthColumn
      }));
    };
    _this.totalsRowHeading = function () {
      var _this$props2 = _this.props,
        i18n = _this$props2.i18n,
        totals = _this$props2.totals,
        totalsName = _this$props2.totalsName;
      var totalsLabel = totalsName ? totalsName : {
        singular: i18n.translate('Polaris.DataTable.totalRowHeading'),
        plural: i18n.translate('Polaris.DataTable.totalsRowHeading')
      };
      return totals && totals.filter(function (total) {
        return total !== '';
      }).length > 1 ? totalsLabel.plural : totalsLabel.singular;
    };
    _this.renderTotals = function (_ref3) {
      var total = _ref3.total,
        index = _ref3.index;
      var fixedFirstColumns = _this.fixedFirstColumns();
      var id = "totals-cell-".concat(index);
      var _this$props3 = _this.props,
        _this$props3$truncate = _this$props3.truncate,
        truncate = _this$props3$truncate === void 0 ? false : _this$props3$truncate,
        verticalAlign = _this$props3.verticalAlign,
        columnContentTypes = _this$props3.columnContentTypes;
      var content;
      var contentType;
      if (index === 0) {
        content = _this.totalsRowHeading();
      }
      if (total !== '' && index > 0) {
        contentType = columnContentTypes[index];
        content = total;
      }
      var totalInFooter = _this.props.showTotalsInFooter;
      return /*#__PURE__*/React.createElement(Cell, {
        total: true,
        totalInFooter: totalInFooter,
        nthColumn: index <= fixedFirstColumns - 1,
        firstColumn: index === 0,
        key: id,
        content: content,
        contentType: contentType,
        truncate: truncate,
        verticalAlign: verticalAlign
      });
    };
    _this.getColSpan = function (rowLength, headingsLength, contentTypesLength, cellIndex) {
      // We decided that it shouldn't be possible to have fixed "n" columns and content that spans multiple columns
      var fixedFirstColumns = _this.fixedFirstColumns();
      if (fixedFirstColumns) {
        return 1;
      }
      var rowLen = rowLength ? rowLength : 1;
      var colLen = headingsLength ? headingsLength : contentTypesLength;
      var colSpan = Math.floor(colLen / rowLen);
      var remainder = colLen % rowLen;
      return cellIndex === 0 ? colSpan + remainder : colSpan;
    };
    _this.defaultRenderRow = function (_ref4) {
      var row = _ref4.row,
        index = _ref4.index,
        inFixedNthColumn = _ref4.inFixedNthColumn,
        rowHeights = _ref4.rowHeights;
      var _this$props4 = _this.props,
        columnContentTypes = _this$props4.columnContentTypes,
        _this$props4$truncate = _this$props4.truncate,
        truncate = _this$props4$truncate === void 0 ? false : _this$props4$truncate,
        verticalAlign = _this$props4.verticalAlign,
        _this$props4$hoverabl = _this$props4.hoverable,
        hoverable = _this$props4$hoverabl === void 0 ? true : _this$props4$hoverabl,
        headings = _this$props4.headings;
      var condensed = _this.state.condensed;
      var fixedFirstColumns = _this.fixedFirstColumns();
      var className = classNames(styles.TableRow, hoverable && styles.hoverable);
      return /*#__PURE__*/React.createElement("tr", {
        key: "row-".concat(index),
        className: className,
        onMouseEnter: _this.handleHover(index),
        onMouseLeave: _this.handleHover()
      }, row.map(function (content, cellIndex) {
        var hovered = index === _this.state.rowHovered;
        var id = "cell-".concat(cellIndex, "-row-").concat(index);
        var colSpan = _this.getColSpan(row.length, headings.length, columnContentTypes.length, cellIndex);
        return /*#__PURE__*/React.createElement(Cell, {
          key: id,
          content: content,
          contentType: columnContentTypes[cellIndex],
          nthColumn: cellIndex <= fixedFirstColumns - 1,
          firstColumn: cellIndex === 0,
          truncate: truncate,
          verticalAlign: verticalAlign,
          colSpan: colSpan,
          hovered: hovered,
          style: rowHeights ? {
            height: "".concat(rowHeights[index], "px")
          } : {},
          inFixedNthColumn: condensed && inFixedNthColumn
        });
      }));
    };
    _this.defaultOnSort = function (headingIndex) {
      var _this$props5 = _this.props,
        onSort = _this$props5.onSort,
        _this$props5$defaultS = _this$props5.defaultSortDirection,
        defaultSortDirection = _this$props5$defaultS === void 0 ? 'ascending' : _this$props5$defaultS,
        initialSortColumnIndex = _this$props5.initialSortColumnIndex;
      var _this$state3 = _this.state,
        _this$state3$sortDire = _this$state3.sortDirection,
        sortDirection = _this$state3$sortDire === void 0 ? defaultSortDirection : _this$state3$sortDire,
        _this$state3$sortedCo = _this$state3.sortedColumnIndex,
        sortedColumnIndex = _this$state3$sortedCo === void 0 ? initialSortColumnIndex : _this$state3$sortedCo;
      var newSortDirection = defaultSortDirection;
      if (sortedColumnIndex === headingIndex) {
        newSortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
      }
      var handleSort = function handleSort() {
        _this.setState({
          sortDirection: newSortDirection,
          sortedColumnIndex: headingIndex
        }, function () {
          if (onSort) {
            onSort(headingIndex, newSortDirection);
          }
        });
      };
      return handleSort;
    };
    return _this;
  }
  _inherits(DataTableInner, _PureComponent);
  return _createClass(DataTableInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;
      // We need to defer the calculation in development so the styles have time to be injected.
      if (process.env.NODE_ENV === 'development') {
        setTimeout(function () {
          _this5.handleResize();
        }, 10);
      } else {
        this.handleResize();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (isEqual(prevProps, this.props)) {
        return;
      }
      this.handleResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
        _this$table$current,
        _this$table$current2,
        _columnVisibilityData;
      var _this$props6 = this.props,
        headings = _this$props6.headings,
        totals = _this$props6.totals,
        showTotalsInFooter = _this$props6.showTotalsInFooter,
        rows = _this$props6.rows,
        footerContent = _this$props6.footerContent,
        _this$props6$hideScro = _this$props6.hideScrollIndicator,
        hideScrollIndicator = _this$props6$hideScro === void 0 ? false : _this$props6$hideScro,
        _this$props6$increase = _this$props6.increasedTableDensity,
        increasedTableDensity = _this$props6$increase === void 0 ? false : _this$props6$increase,
        _this$props6$hasZebra = _this$props6.hasZebraStripingOnData,
        hasZebraStripingOnData = _this$props6$hasZebra === void 0 ? false : _this$props6$hasZebra,
        _this$props6$stickyHe = _this$props6.stickyHeader,
        stickyHeader = _this$props6$stickyHe === void 0 ? false : _this$props6$stickyHe,
        _this$props6$hasFixed = _this$props6.hasFixedFirstColumn,
        fixedFirstColumn = _this$props6$hasFixed === void 0 ? false : _this$props6$hasFixed,
        pagination = _this$props6.pagination;
      var _this$state4 = this.state,
        condensed = _this$state4.condensed,
        columnVisibilityData = _this$state4.columnVisibilityData,
        isScrolledFarthestLeft = _this$state4.isScrolledFarthestLeft,
        isScrolledFarthestRight = _this$state4.isScrolledFarthestRight;
      if (fixedFirstColumn && process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Deprecation: The `hasFixedFirstColumn` prop on the `DataTable` has been deprecated. Use fixedFirstColumns={n} instead.');
      }
      var fixedFirstColumns = this.fixedFirstColumns();
      var rowCountIsEven = rows.length % 2 === 0;
      var className = classNames(styles.DataTable, condensed && styles.condensed, totals && styles.ShowTotals, showTotalsInFooter && styles.ShowTotalsInFooter, hasZebraStripingOnData && styles.ZebraStripingOnData, hasZebraStripingOnData && rowCountIsEven && styles.RowCountIsEven);
      var wrapperClassName = classNames(styles.TableWrapper, condensed && styles.condensed, increasedTableDensity && styles.IncreasedTableDensity, stickyHeader && styles.StickyHeaderEnabled);
      var headingMarkup = /*#__PURE__*/React.createElement("tr", null, headings.map(function (heading, index) {
        return _this6.renderHeading({
          heading: heading,
          headingIndex: index,
          inFixedNthColumn: false,
          inStickyHeader: false
        });
      }));
      var totalsMarkup = totals ? /*#__PURE__*/React.createElement("tr", null, totals.map(function (total, index) {
        return _this6.renderTotals({
          total: total,
          index: index
        });
      })) : null;
      var nthColumns = rows.map(function (row) {
        return row.slice(0, fixedFirstColumns);
      });
      var nthHeadings = headings.slice(0, fixedFirstColumns);
      var nthTotals = totals === null || totals === void 0 ? void 0 : totals.slice(0, fixedFirstColumns);
      var tableHeaderRows = (_this$table$current = this.table.current) === null || _this$table$current === void 0 ? void 0 : _this$table$current.children[0].childNodes;
      var tableBodyRows = (_this$table$current2 = this.table.current) === null || _this$table$current2 === void 0 ? void 0 : _this$table$current2.children[1].childNodes;
      var headerRowHeights = getRowClientHeights(tableHeaderRows);
      var bodyRowHeights = getRowClientHeights(tableBodyRows);
      var fixedNthColumnMarkup = condensed && fixedFirstColumns !== 0 && /*#__PURE__*/React.createElement("table", {
        className: classNames(styles.FixedFirstColumn, !isScrolledFarthestLeft && styles.separate),
        style: {
          width: "".concat((_columnVisibilityData = columnVisibilityData[fixedFirstColumns - 1]) === null || _columnVisibilityData === void 0 ? void 0 : _columnVisibilityData.rightEdge, "px")
        }
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
        style: {
          height: "".concat(headerRowHeights[0], "px")
        }
      }, nthHeadings.map(function (heading, index) {
        return _this6.renderHeading({
          heading: heading,
          headingIndex: index,
          inFixedNthColumn: true,
          inStickyHeader: false
        });
      })), totals && !showTotalsInFooter && /*#__PURE__*/React.createElement("tr", {
        style: {
          height: "".concat(headerRowHeights[1], "px")
        }
      }, nthTotals === null || nthTotals === void 0 ? void 0 : nthTotals.map(function (total, index) {
        return _this6.renderTotals({
          total: total,
          index: index
        });
      }))), /*#__PURE__*/React.createElement("tbody", null, nthColumns.map(function (row, index) {
        return _this6.defaultRenderRow({
          row: row,
          index: index,
          inFixedNthColumn: true,
          rowHeights: bodyRowHeights
        });
      })), totals && showTotalsInFooter && /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, nthTotals === null || nthTotals === void 0 ? void 0 : nthTotals.map(function (total, index) {
        return _this6.renderTotals({
          total: total,
          index: index
        });
      }))));
      var bodyMarkup = rows.map(function (row, index) {
        return _this6.defaultRenderRow({
          row: row,
          index: index,
          inFixedNthColumn: false
        });
      });
      var footerMarkup = footerContent ? /*#__PURE__*/React.createElement("div", {
        className: styles.Footer
      }, footerContent) : null;
      var paginationMarkup = pagination ? /*#__PURE__*/React.createElement(Pagination, Object.assign({
        type: "table"
      }, pagination)) : null;
      var headerTotalsMarkup = !showTotalsInFooter ? totalsMarkup : null;
      var footerTotalsMarkup = showTotalsInFooter ? /*#__PURE__*/React.createElement("tfoot", null, totalsMarkup) : null;
      var navigationMarkup = function navigationMarkup(location) {
        return hideScrollIndicator ? null : /*#__PURE__*/React.createElement(Navigation, {
          columnVisibilityData: columnVisibilityData,
          isScrolledFarthestLeft: isScrolledFarthestLeft,
          isScrolledFarthestRight: isScrolledFarthestRight,
          navigateTableLeft: _this6.navigateTable('left'),
          navigateTableRight: _this6.navigateTable('right'),
          fixedFirstColumns: fixedFirstColumns,
          setRef: function setRef(ref) {
            if (location === 'header') {
              _this6.headerNav = ref;
            } else if (location === 'sticky') {
              _this6.stickyNav = ref;
            }
          }
        });
      };
      var stickyHeaderMarkup = stickyHeader ? /*#__PURE__*/React.createElement(AfterInitialMount, null, /*#__PURE__*/React.createElement("div", {
        className: styles.StickyHeaderWrapper,
        role: "presentation"
      }, /*#__PURE__*/React.createElement(Sticky, {
        boundingElement: this.dataTable.current,
        onStickyChange: function onStickyChange(isSticky) {
          _this6.changeHeadingFocus();
          _this6.stickyHeaderActive = isSticky;
        }
      }, function (isSticky) {
        var stickyHeaderInnerClassNames = classNames(styles.StickyHeaderInner, isSticky && styles['StickyHeaderInner-isSticky']);
        var stickyHeaderTableClassNames = classNames(styles.StickyHeaderTable, !isScrolledFarthestLeft && styles.separate);
        return /*#__PURE__*/React.createElement("div", {
          className: stickyHeaderInnerClassNames
        }, /*#__PURE__*/React.createElement("div", null, navigationMarkup('sticky')), /*#__PURE__*/React.createElement("table", {
          className: stickyHeaderTableClassNames,
          ref: _this6.stickyTable
        }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
          className: styles.StickyTableHeadingsRow
        }, headings.map(function (heading, index) {
          return _this6.renderHeading({
            heading: heading,
            headingIndex: index,
            inFixedNthColumn: Boolean(index <= fixedFirstColumns - 1 && fixedFirstColumns),
            inStickyHeader: true
          });
        })))));
      }))) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassName,
        ref: this.dataTable
      }, stickyHeaderMarkup, navigationMarkup('header'), /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.ScrollContainer,
        ref: this.scrollContainer
      }, /*#__PURE__*/React.createElement(EventListener, {
        event: "resize",
        handler: this.handleResize
      }), /*#__PURE__*/React.createElement(EventListener, {
        capture: true,
        passive: true,
        event: "scroll",
        handler: this.scrollListener
      }), fixedNthColumnMarkup, /*#__PURE__*/React.createElement("table", {
        className: styles.Table,
        ref: this.table
      }, /*#__PURE__*/React.createElement("thead", null, headingMarkup, headerTotalsMarkup), /*#__PURE__*/React.createElement("tbody", null, bodyMarkup), footerTotalsMarkup)), paginationMarkup, footerMarkup));
    }
  }, {
    key: "fixedFirstColumns",
    value: function fixedFirstColumns() {
      var _this$props7 = this.props,
        hasFixedFirstColumn = _this$props7.hasFixedFirstColumn,
        _this$props7$fixedFir = _this$props7.fixedFirstColumns,
        fixedFirstColumns = _this$props7$fixedFir === void 0 ? 0 : _this$props7$fixedFir,
        headings = _this$props7.headings;
      var numberOfFixedFirstColumns = hasFixedFirstColumn && !fixedFirstColumns ? 1 : fixedFirstColumns;
      if (numberOfFixedFirstColumns >= headings.length) {
        return 0;
      }
      return numberOfFixedFirstColumns;
    }

    // eslint-disable-next-line @shopify/react-no-multiple-render-methods

    // eslint-disable-next-line @shopify/react-no-multiple-render-methods
  }]);
}(PureComponent);
function DataTable(props) {
  var i18n = useI18n();
  return /*#__PURE__*/React.createElement(DataTableInner, Object.assign({}, props, {
    i18n: i18n
  }));
}
export { DataTable };